import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';

let originalLaneClosureData = null;

export default class NotificationSchedule {



	static get getNotificationTypeIdOptions() {
		return [
			{
				id: "contravention-new-message",
				name: "Violation - New Message",
				color: 'grey'
			},
			{
				id: "contravention-updated",
				name: "Updated Violation",
				color: 'grey'
			},
			{
				id: "lc-closed",
				name: "Lanes Reported Closed",
				color: 'grey'
			},
			{
				id: "lc-not-closed",
				name: "Report lanes closed by {2} on {1}",

				color: 'grey'
			},
			{
				id: "lc-not-opened",
				name: "Report lanes re-opened by {4} on {3} and/or request a change to the LCR. [ {7} ]",
				color: 'red'
			},
			{
				id: "lc-opened",
				name: "Lanes Reported Re-opened",
				color: 'grey'
			},
			{
				id: "lc-r-not-removed",
				name: "Lanes and Restrictions Not Reported Opened by {4} on {3}. [{6} minutes late] ",
				color: 'red'
			},
			{
				id: "lc-r-reminder-closed",
				name: "Reminder: Closures and Restrictions",
				color: 'orange'
			},
			{
				id: "lc-r-reminder-opened",
				name: "Reminder: Re-Open Lanes and Restrictions",
				color: 'orange'
			},
			{
				id: "lc-reminder-close",
				name: "Reminder: Close lanes by {2} on {1}",
				color: 'orange'
			},
			{
				id: "lc-reminder-open",
				name: "Reminder: Re-open lanes by {4} on {3}",
				color: 'orange'
			},
			{
				id: "lcr-approved",
			name: "Approved Lane Closure Request",
				color: 'green'
			},
			{
				id: "lcr-cancelled",
				name: "Cancelled Lane Closure Request",
				color: 'red'
			},
			{
				id: "lcr-completed",
				name: "Completed Lane Closure Request",
				color: 'grey'
			},
			{
				id: "lcr-new-message",
				name: "New Message",
				color: 'grey'
			},
			{
				id: "lcr-denied",
				name: "Rejected Lane Closure Request",
				color: 'red'
			},
			{
				id: "lcr-updated",
				name: "Updated Lane Closure Request",
				color: 'grey'
			},
			{
				id: "new-contravention",
				name: "New Violation",
				color: 'grey'
			},
			{
				id: "new-lcr",
				name: "New Lane Closure Request",
				color: 'grey'
			},
			{
				id: "new-message",
				name: "New Message",
				color: 'grey'
			},
			{
				id: "r-not-placed",
				name: "Report restrictions placed by {2} on {1}.  [ {6} ]",
				color: 'red'
			},
			{
				id: "r-not-removed",
				name: "Report restrictions removed by {4} on {3} and/or request a change to the LCR. [ {7} ]",
				color: 'red'
			},
			{
				id: "r-placed",
				name: "Restriction reported as placed",
				color: 'grey'
			},
			{
				id: "r-reminder-place",
				name: "Reminder: Report restrictions placed by {2} on {1}",
				color: 'orange'
			},
			{
				id: "r-reminder-remove",
				name: "Reminder: Report restrictions removed by {4} on {3}",
				color: 'orange'
			},
			{
				id: "r-removed",
				name: "Restriction reported as removed",
				color: 'grey'
			},
			{
				id: "lc-reminder-open",
				name: "Reminder: Re-open Lanes by {4} on {3}",
				color: 'orange'
			},
			{
				id: "lc-reminder-close",
				name: "Reminder: Close lanes by {2} on {1}",
				color: 'orange'
			},
			{
				id: "lcr-change-request",
				name: "Change requested for approved lane closure request.",
				color: 'red'
			},

	];
	}



	static get getNotificationScheduleTypeIdOptions() {
		return [
			{
				id: "lc-not-closed",
				name: "Warning: Lanes not closed (x minutes late)",
				schedule: "fromDate",
				text: "LCR {0}: Report lanes closed (X minutes late) ",
				color: 'grey'
			},
			{
				id: "r-not-placed",
				name: "Warning: Turning restrictions not placed (x minutes late)",
				schedule: "fromDate",
				color: 'red'
			},
			{
				id: "lc-not-opened",
				name: "Warning: Lanes not re-opened (x minutes late)",
				schedule: "toDate",
				text: "LCR {0}: Report lanes re-opened (X minutes late) ",
				color: 'red'
			},
			{
				id: "r-not-removed",
				name: "Warning: Restrictions not removed (x minutes late)",
				schedule: "toDate",
				color: 'red'
			},
		// {
		// 	id: "lc-r-not-removed",
		// 	name: "Lanes and Restrictions Not Reported Opened by {4} on {3}. [{6} minutes late] ",
		// 	schedule: "toDate",
		// 	text:"LCR {0}: Report restrictions removed (X minutes late) ",
		// 	color: 'red'
		// },
		// {
		// 	id: "lc-r-reminder-closed",
		// 	name: "Reminder: Closures and Restrictions",
		// 	schedule: "toDate",
		// 	color: 'orange'
		// },
		// {
		// 	id: "lc-r-reminder-opened",
		// 	name: "Reminder: Re-Open Lanes and Restrictions",
		// 	schedule: "toDate",
		// 	color: 'orange'
		// },
			{
				id: "lc-reminder-close",
				name: "Reminder: Close lanes",
				schedule: "fromDate",
				color: 'orange'
			},
			{
				id: "r-reminder-place",
				name: "Reminder: Place turning restrictions",
				schedule: "fromDate",
				color: 'orange'
			},
			{
				id: "lc-reminder-open",
				name: "Reminder: Re-open lanes",
				schedule: "toDate",
				color: 'orange'
			},
			{
				id: "r-reminder-remove",
				name: "Reminder: Remove turning restrictions",
				schedule: "toDate",
				color: 'orange'
			},
		];
	}

	// only used for requested changes to a lane closure request.
	static get getLcrUserTypeOptions() {
		return [
			{
				id: 'all_officers',
				name: "All Enforcement Officers"
			},
			{
				id: 'approver',
				name: "Approver"
			},
			{
				id: 'failed_reopening_closure_contact',
				name: "Failed Reopening Closure Contact"
			},
			{
				id: 'alt_closure_reporter',
				name: "Alternate Closure Reporter(s)"
			},
			{
				id: 'alt_requester',
				name: "Alternate Requester(s)"
			},
			{
				id: 'alt_restriction_reporter',
				name: "Alternate Restriction Reporter(s)"
			},
			{
				id: 'closure_reporter',
				name: "Closure Reporter"
			},
			{
				id: 'requester',
				name: "Requester"
			},
			{
				id: 'restriction_reporter',
				name: "Turning Restriction Reporter"
			},
			{
				id: 'supervisor',
				name: "Supervisor"
			},
			{
				id: 'supervisor_alt',
				name: "Supervisor's Alternate Contact"
			},
			{
				id: 'all_contacts',
				name: "All Contacts"
			},
			{
				id: 'user_in_org',
				name: "Assigned to Organization"
			},
		];
	}

	static getLcrUserTypeText(id) {
		if (id) {
			let txt = this.searchById(id, this.getLcrUserTypeOptions);
			if (txt) {
				return txt.name;
			}
		}
		return null;
	}


	static getNotificationTypeText(id) {
		if (id) {
			let txt = this.searchById(id, this.getNotificationTypeIdOptions);
			if (txt) {
				return txt.name;
			}
		}
		return null;
	}

	static getNotificationScheduleTypeText(id) {
		if (id) {
			let txt = this.searchById(id, this.getNotificationScheduleTypeIdOptions);
			if (txt) {
				return txt.name;
			}
		}
		return null;
	}

	static getMinutesText(id, from, to) {
		let txt = "";
		if (id) {
			let entry = this.searchById(id, this.getNotificationScheduleTypeIdOptions);
			if (entry) {
				let fromnum = from;
				let tonum = to;
				if (from < 0) {
					fromnum = fromnum * -1;
				}
				if (to < 0) {
					tonum = tonum * -1;
				}

				if (from < 0 && to < 0) {
					txt += fromnum + " to " + tonum + " minutes before ";
				} else {
					txt += fromnum + " to " + tonum + " minutes after ";
				}

				if (entry.schedule == "fromDate") {
					txt += " Start Time";
				} else {
					txt += " Completion Time";
				}
			}
		}
		return txt;
	}

	static getDateSourceText(id) {
		let txt = "";
		let entry = this.searchById(id, this.getNotificationScheduleTypeIdOptions);
		if (entry) {
			if (entry.schedule == "fromDate") {
				txt = "Start Time";
			} else {
				txt = "Completion Time";
			}
		}
		return txt;
	}


	static getMinutesAfterBeforeText(id, from, to) {
		let txt = "";
		if (id) {
			let entry = this.searchById(id, this.getNotificationScheduleTypeIdOptions);
			if (entry) {
				if (from < 0 && to < 0) {
					txt += " minutes before ";
				} else {
					txt += " minutes after ";
				}

				if (entry.schedule == "fromDate") {
					txt += " Start Time";
				} else {
					txt += " Completion Time";
				}
			}
		}
		return txt;
	}


	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].id === nameKey) {
				return iArray[i]
			}
		}
	}

	static searchByGroupedId(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].options) {
				for (let ii = 0; ii < iArray[i].options.length; ii++) {
					if (iArray[i].options[ii].id === nameKey) {
						return iArray[i].options[ii]
					}
				}
			}
		}
		return null;
	}



	constructor(data) {
		if (!data) {
			data = {}
		}
		Object.assign(this, {
			id: data.id || null,
			notificationTypeId: new BootstrapField({
				value: data.notificationTypeId || "lc-not-opened",
			}),
			appText: new BootstrapField({
				value: data.appText || null,
			}),
			webText: new BootstrapField({
				value: data.webText || null,
			}),
			lcrText: new BootstrapField({
				value: data.lcrText || null,
			}),
			emailSubject: new BootstrapField({
				value: data.emailSubject || null,
			}),
			emailIntro: new BootstrapField({
				value: data.emailIntro || null,
			}),
			emailClosing: new BootstrapField({
				value: data.emailClosing || null,
			}),
			emailRecipients: new BootstrapField({
				value: data.emailRecipients || null,
			}),
			emailTemplateFile: new BootstrapField({
				value: data.emailTemplateFile || "with-lcr-body",
			}),
			fromMinute: new BootstrapField({
				value: typeof data.fromMinute === 'number' ? data.fromMinute : null,
				required: true,
			}),
			toMinute: new BootstrapField({
				value: typeof data.toMinute === 'number' ? data.toMinute : null,
				required: true,
			}),
			lcrUser: new BootstrapField({
				value: data.lcrUser || "requester",
			}),
			isActive: new BootstrapField({
				value: typeof data.isActive === 'number' ? data.isActive : null,
				required: true,
			}),
			organizationId: new BootstrapField({
				value: data.organizationId || null,
				required: false,
				invalidMessage: "Please select an organization",
				fnRawValue: function() {
					if (this.value == null) {
						return null;
					}
					if (this.value.id != null) {
						return this.value.id;
					} else {
						return null;
					}
				}
			}),
		});

		originalLaneClosureData = this.getRawValue();
	}

	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	hasChanges() {
		// return false;
		return !IsEqual(originalLaneClosureData, this.getRawValue());
	}
	revertChanges() {
		this.constructor(originalLaneClosureData);
	}
	saveChanges() {
		// originalLaneClosureData = CloneDeep(this);
		originalLaneClosureData = this.getRawValue();
	}


}